import { getListString } from "common/helpers/common.helpers";
import {
  EvChargerConnector,
  EvChargerMeta,
  EvChargerSubtype,
  PropertyInfra,
  PropertyInfraType,
} from "../types/api.types";

export const EvChargerSubtypeLabels: Record<EvChargerSubtype, string> = {
  [EvChargerSubtype.Fast]: "Greitoji įkrovimo stotelė",
  [EvChargerSubtype.Slow]: "Lėtoji įkrovimo stotelė",
};

/** Connectors arrive as OCPI standard codes, which mean nothing to a reader. */
const connectorLabels: { [key: string]: string } = {
  IEC_62196_T1: "Type 1",
  IEC_62196_T1_COMBO: "CCS1",
  IEC_62196_T2: "Type 2",
  IEC_62196_T2_COMBO: "CCS2",
  IEC_62196_T3A: "Type 3A",
  IEC_62196_T3C: "Type 3C",
  CHADEMO: "CHAdeMO",
  DOMESTIC_F: "Schuko",
  GBT_AC: "GB/T AC",
  GBT_DC: "GB/T DC",
  TESLA_R: "Tesla",
  TESLA_S: "Tesla",
};

const formatDecimal = (value: number, digits: number) =>
  Number(value.toFixed(digits)).toString().replace(".", ",");

const getConnectorDescription = ({
  type,
  power_kw,
  count,
}: EvChargerConnector) => {
  const label = connectorLabels[type] || type;
  const description =
    power_kw == null ? label : `${label} ${formatDecimal(power_kw, 1)} kW`;

  return count && count > 1 ? `${count} × ${description}` : description;
};

const getEvChargerMeta = (infra: PropertyInfra): EvChargerMeta | undefined =>
  infra.type === PropertyInfraType.EvCharger ? infra.meta ?? {} : undefined;

export const getEvChargerOperator = (infra: PropertyInfra) =>
  getEvChargerMeta(infra)?.operator || undefined;

/** Charging speed and every connector standard, since they differ within one charger. */
export const getEvChargerDescription = (infra: PropertyInfra) => {
  const meta = getEvChargerMeta(infra);
  if (!meta) return undefined;

  const connectors = meta.connectors ?? [];
  const connectorCount = connectors.reduce(
    (total, connector) => total + (connector.count ?? 0),
    0
  );

  return (
    getListString([
      EvChargerSubtypeLabels[infra.subtype as EvChargerSubtype],
      ...connectors.map(getConnectorDescription),
      // The connectors already add up to this number whenever they carry counts.
      !!meta.evse_count && connectorCount !== meta.evse_count
        ? `įkrovimo taškų: ${meta.evse_count}`
        : undefined,
    ]) || undefined
  );
};
